import React from "react";
import AllUserCustomerCoWorker from "../component/sections/user/AllUserCustomerCoWorker";
import AddUserCustomerCoWorker from "../component/sections/user/AddUserCustomerCoWorker";
import ShowInfoCustomerCoworker from "../component/sections/user/ShowInfoCustomerCoworker";
import InfoUser from "../component/sections/user/InfoUser";
import ReportCampaign from "../component/sections/report/ReportCampaign";

const userRoutes = [
  {
    path: "/user/info",
    render: () => <InfoUser />,
    exact: true,
  },
  {
    path: "/user/all-customer-coworker",
    render: () => <AllUserCustomerCoWorker />,
    exact: true,
  },
  {
    path: "/user/add-customer-coworker",
    render: () => <AddUserCustomerCoWorker />,
    exact: true,
  },
  {
    path: "/user/customer-coworker-info/:id",
    render: () => <ShowInfoCustomerCoworker />,
    exact: true,
  },
  {
    path: "/report/coworker/campaign/:id",
    render: () => <ReportCampaign />,
    exact: true,
  },
];

export default userRoutes;
